<template>
  <section class="breadcrumbs-custom">
    <div class="parallax-container">
      <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="breadcrumbs" ></div>
      <div class="breadcrumbs-custom-body parallax-content context-dark">
        <div class="container">
          <h2 class="breadcrumbs-custom-title">Cart Page</h2>
        </div>
      </div>
    </div>
    <div class="breadcrumbs-custom-footer">
      <div class="container">
        <ul class="breadcrumbs-custom-path">
          <li><router-link to="/" class="rd-nav-link">Home</router-link></li>
          <li><router-link to="/our-menu" class="rd-nav-link">Shop</router-link></li>
          <li class="active">Cart Page</li>
        </ul>
      </div>
    </div>
  </section>
  <!-- Shopping Cart-->
  <section class="section section-xl bg-default">
    <div class="container">
      <!-- shopping-cart-->
      <div class="table-custom-responsive">
        <table class="table-custom table-cart">
          <thead>
            <tr>
              <th>Product</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Total</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody v-if="cart.length > 0">
            <tr v-for="item in cart" :key="item.id">
              <td>
                <div class="prod-card-inner"><router-link class="table-cart-figure" :to="item.slug"><img :src="item.image || '/assets/images/dummy_146_132.webp'" onerror="this.onerror=null;this.src='/assets/images/dummy_146_132.webp';" :alt="item.name" width="146" height="132"/></router-link><router-link class="table-cart-link" :to="item.slug">{{ item.name }}</router-link></div>
              </td>
              <td>${{ item.price }}</td>
              <td>
                <div class="quantity d-flex align-items-center justify-content-center">
                  <button class="btn btn-outline-secondary qty-btn" @click="cartStore.updateQuantity(item.product_sku_id, item.quantity - 1)">−</button>
                  <input type="text" class="form-control qty-input" :value="item.quantity" readonly>
                  <button class="btn btn-outline-secondary qty-btn" @click="cartStore.updateQuantity(item.product_sku_id, item.quantity + 1)">+</button>                  
                </div>
              </td>
              <td>${{ item.price * item.quantity }}</td>
              <td><button class="button button-sm button-icon button-icon-left button-default-outline button-zakaria" @click="cartStore.removeFromCart(item.product_sku_id)"><i class="fa fa-times"></i></button></td>
            </tr>                
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="5">
                Your cart is empty
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="group-xl group-justify justify-content-center justify-content-md-between">
        <!-- <div>
          <form class="rd-form rd-mailform rd-form-inline rd-form-coupon">
            <div class="form-wrap">
              <input class="form-input form-input-inverse" id="coupon-code" type="text" name="text">
              <label class="form-label" for="coupon-code">Coupon code</label>
            </div>
            <div class="form-button">
              <button class="button button-lg button-secondary button-zakaria" type="submit">Apply</button>
            </div>
          </form>
        </div> -->
        <div>
          <div class="group-xl group-middle">
            <div>
              <div class="group-md group-middle">
                <div class="heading-5 fw-medium text-gray-500">Total</div>
                <div class="heading-3 fw-normal">${{ subtotal }}</div>
              </div>
            </div><router-link class="button button-lg button-primary button-zakaria" to="/checkout">Proceed to checkout</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { onMounted } from 'vue';
import { useCartStore } from '@/stores/cart'
import { storeToRefs } from 'pinia'
import { useCommonStore } from '@/stores/commonStore';

const commonStore = useCommonStore()

const cartStore = useCartStore()
const { cart, subtotal } = storeToRefs(cartStore)

onMounted(async () => {
  commonStore.loaderVisible = true;     
  
  const scriptId = 'script-js-script'

  // Check if the script already exists
  const existingScript = document.getElementById(scriptId)

  if (existingScript) {
      // Replace it: remove and re-add
      existingScript.remove()
  }

  // Create and append a fresh script
  const newScript = document.createElement('script')
  newScript.src = '/assets/js/script.js'
  newScript.id = scriptId
  document.body.appendChild(newScript)

  // Wait for the script to load
  await new Promise((resolve) => {
    newScript.onload = resolve
  })
  
  window.scrollTo(0, 0)
  
  cartStore.loadCart()

  commonStore.loaderVisible = false;   
})
</script>